import { render, staticRenderFns } from "./distinguish_restart_stage.vue?vue&type=template&id=52c02b14&scoped=true"
var script = {}
import style0 from "./distinguish_restart_stage.vue?vue&type=style&index=0&id=52c02b14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c02b14",
  null
  
)

export default component.exports